import React, { useState } from 'react';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';

const PhotoGallery = ({ images = [], columns = 4, gap = '2' }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

const schoolImages = [
    { id: 2, src: '/images/classroom.jpg', alt: 'Happy students in classroom' },
    { id: 3, src: '/images/computer.jpg', alt: 'Students working on computers' },
    //   { id: 4, src: '/images/dis (1).jpg', alt: 'Activity time 1' },
    { id: 5, src: '/images/dis (2).jpg', alt: 'Activity time 2' },
    { id: 6, src: '/images/dis (3).jpg', alt: 'Teacher guiding students' },
    { id: 7, src: '/images/dis (4).jpg', alt: 'Creative classroom activity' },
    { id: 8, src: '/images/dis (5).jpg', alt: 'Learning with fun' },
    { id: 9, src: '/images/dis (9).jpg', alt: 'Science class' },
    { id: 10, src: '/images/lab.jpg', alt: 'Computer lab activity' },
    { id: 11, src: '/images/lab2.jpg', alt: 'Science lab experiment' },
    { id: 12, src: '/images/library.jpg', alt: 'Library reading time' },
    { id: 1, src: '/images/children.png', alt: 'Children in classroom' },
  { id: 13, src: '/images/sports.jpg', alt: 'Sports and fun' },
  { id: 14, src: '/images/students.jpg', alt: 'Group of students' },
  { id: 15, src: '/images/teachers.jpg', alt: 'Teachers and students' },
    { id: 16, src: '/images/001.jpeg', alt: 'School assembly' },
    { id: 17, src: '/images/002.jpeg', alt: 'Outdoor activity' },
];

  const galleryImages = images.length > 0 ? images : schoolImages;

  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    let newIndex;
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % galleryImages.length;
    } else {
      newIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    }
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const handleKeyDown = (e) => {
    if (!selectedImage) return;
    
    switch(e.key) {
      case 'Escape':
        closeModal();
        break;
      case 'ArrowRight':
        navigateImage('next');
        break;
      case 'ArrowLeft':
        navigateImage('prev');
        break;
      default:
        break;
    }
  };

  // Responsive column classes
  const getColumnClass = () => {
    const colMap = {
      1: 'md:col-12 lg:col-12',
      2: 'md:col-6 lg:col-6',
      3: 'md:col-4 lg:col-4',
      4: 'md:col-3 lg:col-3',
      6: 'md:col-2 lg:col-2'
    };
    return colMap[columns] || 'md:col-3 lg:col-3';
  };

  return (
    <div className="photo-gallery" onKeyDown={handleKeyDown} tabIndex={0}>
      {/* Main Gallery Grid */}
      <div className='flex flex-wrap justify-content-end align-items-center'
    //    className={`grid grid-nogutter gap-${gap}`}
      >
        {galleryImages.map((image, index) => (
          <div 
            key={image.id} 
            className={`col-12 ${getColumnClass()} cursor-pointer`}
            onClick={() => handleImageClick(image, index)}
          >
            <div className="gallery-item card border-1 surface-border border-round">
              <div className="flex align-items-center justify-content-center">
                <img 
                  src={image.thumbnail || image.src} 
                  alt={image.alt}
                  className="w-full border-round"
                  style={{ 
                    objectFit: 'cover', 
                    height: '300px',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                  }}
                />
              </div>
              {image.caption && (
                <div className="p-2 text-center">
                  <p className="text-sm text-700">{image.caption}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Zoom Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div 
            className="modal-content" 
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button 
              className="close-button p-button p-component p-button-rounded p-button-text p-button-plain"
              onClick={closeModal}
              aria-label="Close"
            >
              <i className="pi pi-times"></i>
            </button>

            {/* Navigation Buttons */}
            {galleryImages.length > 1 && (
              <>
                <button 
                  className="nav-button prev-button p-button p-component p-button-rounded p-button-text"
                  onClick={() => navigateImage('prev')}
                  aria-label="Previous image"
                >
                  <i className="pi pi-chevron-left"></i>
                </button>
                <button 
                  className="nav-button next-button p-button p-component p-button-rounded p-button-text"
                  onClick={() => navigateImage('next')}
                  aria-label="Next image"
                >
                  <i className="pi pi-chevron-right"></i>
                </button>
              </>
            )}

            {/* Main Image */}
            <div className="image-container">
              <img 
                src={selectedImage.src} 
                alt={selectedImage.alt}
                className="zoomed-image"
              />
            </div>

            {/* Image Info */}
            <div className="image-info">
              <h3>{selectedImage.alt}</h3>
              {selectedImage.description && (
                <p>{selectedImage.description}</p>
              )}
              <div className="image-counter">
                {currentIndex + 1} / {galleryImages.length}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoGallery;